import { Role } from "approot/school/orginfo/securityrights/securityrights.model";
import { FuncType } from "./models/common.model";
import { AppContext } from "./services/context";
import { Metrika } from "./webapp/services/metrika.service";

export class AddYaCounters {
	constructor(
		public appContext: AppContext,
		public metrika: Metrika,
		public $q: ng.IQService,
		public language: any
	) {

	}

	getRoleName() {
		let roleName = this.language.Generic.Common.kStaff;
		if (this.appContext.hasRole(Role.Student)) {
			roleName = this.language.Generic.Common.kLearner
		} else if (this.appContext.hasRole(Role.Parent)) {
			roleName = this.language.Generic.Common.kParent
		}
		return roleName;
	}

	getOoType() {
		let ooType = "";
		switch (this.appContext.funcType) {
			case FuncType.preSchool:
				ooType = this.language.Generic.Common.kFuncType_PreSchool
				break;
			case FuncType.school:
				ooType = this.language.Generic.Common.kFuncType_School
				break;
			case FuncType.addSchool:
				ooType = this.language.Generic.Common.kFuncType_AddSchool
				break;
			case FuncType.profSchool:
				ooType = this.language.Generic.Common.kFuncType_ProfSchool
				break;
			case FuncType.orphanage:
				ooType = this.language.Generic.Common.kFuncType_Orphanage
				break;
			default:
				ooType = this.language.Generic.Common.kEMName
				break;
		}
		return ooType;
	}

	public execute() {
		if (this.appContext.yaCounterOff) {
			return;
		}

		let params: any = {
			productName: this.appContext.productName,
			environment: this.appContext.environment,
			version: this.appContext.version,
			serverId: this.appContext.serverId
		}

		if (this.appContext.organizationName) {
			params.ooType = this.getOoType();
			params.ooName = this.appContext.organizationName;
			params.role = this.getRoleName();
		}

		let yandexCounterConfig = {
			id: 28935260,
			accurateTrackBounce: true,
			ut: "noindex",
			params: params
		}

		if (!this.appContext.yaCounterOff) {
			this.metrika.init([yandexCounterConfig], yandexCounterConfig.id);
			this.metrika.insertMetrika();
			this.appContext.yaCounters = [this.metrika];
			if (this.appContext.yaCounterCode) {
				let addMetrika = new Metrika(this.$q);
				let addParams = Object.assign({}, params);
				let addYandexCounterConfig = {
					id: +this.appContext.yaCounterCode,
					accurateTrackBounce: true,
					ut: "noindex",
					params: addParams
				}
				addMetrika.init([addYandexCounterConfig], addYandexCounterConfig.id);
				addMetrika.insertMetrika();
				this.appContext.yaCounters.push(addMetrika);
			}
		}
	}
}